import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const SidebarMenu = ({ className, ...props }: ComponentProps<"ul">) => (
  <ul
    data-slot="sidebar-menu"
    className={cn(
      "flex w-full flex-col gap-0.5 group-data-[state=collapsed]/sidebar:items-center group-data-[state=collapsed]/sidebar:gap-1.5",
      className,
    )}
    {...props}
  />
);
